import React, { useEffect, useState} from 'react';
import { BrowserRouter, Route, Switch  } from 'react-router-dom'
import _ from 'lodash';
import './App.css';
import {queryString} from "@/util";
import '@/assets/css/base/base.scss';
import intl from 'react-intl-universal';
import Header from '@/components/Head'
import Footer from '@/components/footer'
// 引入展示组件
import { HomePage, GoodsPage, GoodsIdPage, GoodsDecPage, VipPage, NewsPage, NewsIdPage, StorePage, StoryPage, SearchGoodsPage } from './views';

const locales = {
  "en-US": require('./locale/en.json'),
  "zh-CN": require('./locale/zh.json'),
};
const SUPPOER_LOCALES = [
  {
    name: 'English',
    value: 'en-US'
  },
  {
    name: '简体中文',
    value: 'zh-CN'
  }
];

function App() {
  const [initDone, setInitDone] = useState(false)
  const [langClass, setLangClass] = useState('')

  const loadLocalLang = () => {
    let currentLocale = queryString('lang')
    // eslint-disable-next-line no-unused-expressions
    currentLocale && currentLocale === 'en-US' ? setLangClass(' en') : null
    if (!_.find(SUPPOER_LOCALES, { value: currentLocale })) {
      currentLocale = 'zh-CN';
    }
    intl.init({
      currentLocale, // TODO: determine locale here
      locales: {
        [currentLocale]: locales[currentLocale]
      },
    }).then(() => {
      setInitDone(true)
    })
  }
  useEffect(() => {
    loadLocalLang()
  })
  return (
      initDone &&
      (
          <BrowserRouter>
            <div className={['App ', langClass]}>
              <Header />
              <Switch>
                <Route path='/' exact component={HomePage}/>
                <Route path='/goods' exact component={GoodsPage}/>
                <Route path='/goods/:id?' exact component={GoodsIdPage}/>
                <Route path='/search' exact component={SearchGoodsPage}/>
                <Route path='/dec/:id' exact component={GoodsDecPage}/>
                <Route path='/vip' exact component={VipPage}/>
                <Route path='/news' exact component={NewsPage}/>
                <Route path='/news/:id' exact component={NewsIdPage}/>
                <Route path='/store' exact component={StorePage}/>
                <Route path='/story' exact component={StoryPage}/>
              </Switch>
              <Footer />
            </div>
          </BrowserRouter>
      )
  );
}

export default App;
